import React from 'react';

class BlankPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return null;
    }
}

BlankPage.meta = {
    hide: true,
    locations: ['/blank']
};

export default BlankPage;



// WEBPACK FOOTER //
// ./src/pages/blank/index.jsx